import { elements, isVisible } from "./base";
/**
 * ANIMATION ON SCROLL (https://javascript.info/onscroll)
 */
export const animateInView = () => {
  const { animationElements } = elements;

  if (animationElements) {
    animationElements.forEach((el) => {
      if (isVisible(el)) el.classList.add("in-view");
    });
  }
};

export const highlightInView = () => {
  const { highlightEl } = elements;

  if (highlightEl) {
    highlightEl.forEach((el) => {
      if (isVisible(el)) el.classList.add("in-view");
    });
  }
};

/**
 * SCROLL ON BUTTON (https://www.youtube.com/watch?v=oUSvlrDTLi4)
 */
/* 
export const smoothScroll = (target, duration) => {
  const targetElement = document.querySelector(target);
  const targetPosition = targetElement.offsetTop - 25;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime = null;
  let timeElapsed, run;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;

    timeElapsed = currentTime - startTime;
    run = ease(timeElapsed, startPosition, distance, duration);

    window.scrollTo(0, run);

    if (timeElapsed < duration) requestAnimationFrame(animation);
  }

  function ease(t, b, c, d) {
    t /= d;
    t--;
    return c * (t * t * t + 1) + b;
  }

  requestAnimationFrame(animation);
}; 
*/
